<template>
  <table ref="table" :class="['datatable-v3 w-full', { lightTheme }]">
    <slot></slot>
  </table>
</template>

<script setup lang="ts">
import { nextTick, onBeforeMount, onMounted, ref } from "vue";

// Fire-and-forget so nothing waits on it; preloadErrorHandler keeps a failed
// fetch from rejecting.
onBeforeMount(() => {
  import("./datatable_tailwind.css");
});

defineProps<{ lightTheme?: boolean }>();
const table = ref(null);

onMounted(() => {
  attachColumnHover();
});

const attachColumnHover = () => {
  nextTick(() => {
    $(table.value).on("mouseenter ", "th", function () {
      // $(".datatable-v3 .dt-scroll-head table").on("mouseenter ", "th", function () {
      // Remove highlight from all columns
      $(table.value).find(".cell-hover").removeClass("cell-hover");
      const index = parseInt($(this).index()) + 1;
      $(table.value).find(`td:nth-child(${index})`).addClass("cell-hover");
      $(this).addClass("cell-hover");
    });
    $(table.value).on("mouseleave ", "th", function () {
      $(table.value).find(".cell-hover").removeClass("cell-hover");
    });
  });
};
</script>

<style lang="scss" scoped>
.table {
  width: 100%;
  color: var(--darkblue);
  box-shadow: var(--box-shadow);
  border-radius: 5px;
  thead {
    th {
      color: #fff;
      background-color: var(--primary-accent);
      padding: 5px;
      &:first-of-type {
        border-radius: 5px 0 0;
      }
      &:last-of-type {
        border-radius: 0 5px 0 0;
      }
    }
  }
  tbody {
    width: 100%;
    border: 1px solid #ededed;
    border-top: none;
    box-sizing: border-box;
  }
  tr {
    width: 100%;
    background-color: var(--white);
    &:nth-child(even) {
      background-color: var(--angel-blue);
    }
    td,
    th {
      padding: 5px;
      border: none;
      &:first-of-type {
        padding-left: 10px;
      }
    }
    th {
      a,
      .link {
        color: #fff !important;
        text-decoration: underline;
      }
    }
    td {
      color: var(--darkblue);
    }
  }
}
.lightTheme thead th {
  color: black !important;
  background-color: white !important;
}

tfoot {
  font-weight: bold;
  td {
    background-color: var(--medium-color);
  }
}

table.job-times-table {
  tbody > tr > td {
    vertical-align: top !important;
  }

  thead > tr > th:last-child,
  tfoot > tr > td:last-child,
  tbody > tr > td:last-child {
    padding-right: 10px;
  }
  .duration-time-header {
    width: 10%;
    text-align: right;
  }
}
</style>
